export const ENGAGEMENT_STRATEGIES = ['Pursue', 'Nurture', 'Hold', 'Monitor'];
export const STALLED_DAYS = 56; // 8 weeks
export const CUSTOMER_STALLED_DAYS = 90; // extended threshold for existing customers
export const REACHED_OUTCOME = 'Reached';

export function classifyEngagement(days, stalled, strategy) {
  if (stalled) return { tier: 'Stalled', color: 'error' };
  if (strategy === 'Hold') return { tier: 'Hold', color: 'default' };
  if (strategy === 'Nurture') {
    if (days >= CUSTOMER_STALLED_DAYS) return { tier: 'Nurture Aging', color: 'warning' };
    return { tier: 'Nurture', color: 'info' };
  }
  if (days < 15) return { tier: 'Fresh', color: 'success' };
  if (days < 42) return { tier: 'Aging', color: 'warning' };
  return { tier: 'At Risk', color: 'error' };
}

export function shouldStall({ status, days, hasFutureFollowUp, strategy, type }) {
  if (status === 'Closed Won' || status === 'Closed Lost') return false;
  if (strategy === 'Hold') return false; // holds opted out
  const threshold = type === 'Customer' ? CUSTOMER_STALLED_DAYS : STALLED_DAYS;
  return days >= threshold && !hasFutureFollowUp;
}
